//imports
import {
    MANUFACTURER_DELETE_OPEN_MODAL,
    MANUFACTURER_DELETE_REQUEST,
    MANUFACTURER_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    manufacturer: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case MANUFACTURER_DELETE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, manufacturer: action.payload.man }

        case MANUFACTURER_DELETE_REQUEST:
            return { ...state, loading: true }

        case MANUFACTURER_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "MANUFACTURER_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};